export const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
export const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/